<template>
    <div :id="id"> 
        <div class="table">
            <table class="table__container">
                <tr>
                    <td class="table__header table__header__first init_dates">
                        預報日期
                    </td>
                    <td v-for="row_date in row_dates" 
                        :key="row_date.date" 
                        class="table__header table__header__border"
                    >
                        <div class="row_dates">
                            {{ row_date.date }}
                        </div>
                    </td>
                </tr>
                <tr 
                    v-for="(column_date, column_index) in column_dates"
                    :key="column_date.date" 
                >
                    <td class="table__sidebar init_dates init_date__container"
                        :class="[
                            column_index % 2 === 0 ? 'table__sidebar__even' : 'table__sidebar__odd',
                            column_index === column_dates.length -1 ? 'table__sidebar__last_child': ''
                        ]"
                    >
                        <font v-if="column_index === 0">
                            預報初始時間 <br>
                        </font>
                        <font> {{ column_date.date }} </font>
                    </td>

                    <td v-for="(image, row_index) in structured_images[column_date.date]"
                        :key="column_date.date + row_index"
                    >
                        <v-img :src="get_src(image, compression)"
                            aspect-ratio="1"
                            @click="show_detailed_picture(image)"
                            @error="change_src(image)"
                            id="img_id_for_selector"
                            contain
                        />
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
    
<script>
    import { 
        atlas_root_dir, 
        EC_taiwan_daily_rain_images_dir, 
        alt_src, 
    } from "../../../config/atlas_route_config.js"
    import { atlas_newest_data_single_txt_ajax } from "@/utils/atlas/atlas.js"

    export default {
        name: 'AtlasTableDate',

        props: {
            id: {
                type: String,
                required:true,
            },

            row_date_count: {
                type: Number,
                default() {
                    return 9
                }
            },
            
            column_date_count: {
                type: Number,
                default() {
                    return 7
                }
            },

            images_dir: {
                type: String,
                required: true,
            },

            compression: {
                type: Boolean,
                default() {
                    return false
                } 
            },

            file_name: {
                type: Object,
                default() {
                    return {}
                } 
            }
        },

        data() {
            return {
                structured_images: [],
                column_dates: [],
                row_dates: [],

                newest_date: '',
                newest_year: new Date().getFullYear(),
                newest_hour: '12',
            }
        },
        
        created() {
            this.init_atlas()
        },

        methods: {
            async init_atlas() {
                const response = await atlas_newest_data_single_txt_ajax(`${atlas_root_dir}${this.images_dir}`)
                const date_split = response.data.split(',')
                this.newest_date = date_split[0]
                this.newest_hour = date_split[1]
                this._get_row_dates();
                this._get_column_dates();
                this._generate_images()
            },

            set_init_date_size() {
                try {
                    const pic_size = document.querySelectorAll(`#${this.id} #img_id_for_selector`)[0].clientWidth;
                    const init_dates = document.querySelectorAll(`#${this.id} .init_dates`);
                    init_dates.forEach(init_date => {
                        init_date.style.width = (1.5 * pic_size) + "px";
                        init_date.style.height= (pic_size) + "px";
                    })   
                }
                catch (error) {
                    console.error(error)
                }
            },

            _get_row_dates() {
                let calculated_date = new Date(this.newest_date);
                calculated_date.setDate(calculated_date.getDate() - 3);
                const row_dates = [];
                for(let i=0; i <= this.row_date_count-1; i++) {
                    calculated_date.setDate(calculated_date.getDate() + 1);
                    const year = calculated_date.getFullYear();
                    const month = this.fillzero(calculated_date.getMonth() + 1);
                    const date = this.fillzero(calculated_date.getDate());
                    const date_obj = {
                        year,
                        date: month + date
                    }
                    row_dates.push(date_obj);
                }
                this.row_dates = row_dates;
            },
            
            _get_column_dates() {
                let calculated_date = new Date(this.newest_date);
                const column_dates = [];
                for(let i=0; i <= this.column_date_count-1; i++) {
                    const year = calculated_date.getFullYear();
                    const month = this.fillzero(calculated_date.getMonth() + 1);
                    const date = this.fillzero(calculated_date.getDate());
                    const date_obj = {
                        year,
                        date: month + date
                    }
                    column_dates.push(date_obj);
                    calculated_date.setDate(calculated_date.getDate() - 1);
                }
                this.column_dates = column_dates;
            },

            generate_file_name({atlas_root_dir, images_dir, newest_year, newest_hour, column_date, index}) {
                return `${atlas_root_dir}${images_dir}/${newest_year}${column_date}${this.file_name.prefix}${index}${this.file_name.suffix}.${this.file_name.type}`  ;
            },

            _generate_images() {
                let structured_images = {};
                let accumulated_precipitation_dates = this.get_accumulated_precipitation_dates();

                this.column_dates.slice(0,1).forEach((column_date, index) => {
                    const row_images = []
                    
                    for (let i=1; i <= 2; i++) {
                        row_images.push({'src': null, 'alt_image': alt_src, 'failed': false});
                    }

                    row_images.push({
                        'src': `${atlas_root_dir}${EC_taiwan_daily_rain_images_dir}${accumulated_precipitation_dates[index]}_0800.QZX.jpg`,
                        'alt_image': alt_src, 'failed': false}
                    )

                    for (let i=1; i <= this.row_dates.length-3; i++) {
                        row_images.push({
                            'src': this.generate_file_name({
                                atlas_root_dir, 
                                images_dir: this.images_dir, 
                                newest_year: column_date.year, 
                                column_date: column_date.date, 
                                index: i, 
                                newest_hour: this.newest_hour
                            }),
                            'alt_image': alt_src, 
                            'failed': false
                        });
                    }

                    structured_images[column_date.date] = row_images
                })

                this.column_dates.slice(1,3).forEach((column_date, index) => {
                    const row_images = []
                    
                    for (let i=1; i <= 1-index; i++) {
                        row_images.push({'src': null, 'alt_image': alt_src, 'failed': false});
                    }

                    row_images.push({
                        'src': `${atlas_root_dir}${EC_taiwan_daily_rain_images_dir}${accumulated_precipitation_dates[index+1]}_0800.QZX.jpg`,
                        'alt_image': alt_src, 'failed': false}
                    )

                    for (let i=1; i <= this.row_dates.length-3; i++) {
                        row_images.push({
                            'src': this.generate_file_name({
                                atlas_root_dir, 
                                images_dir: this.images_dir, 
                                newest_year: column_date.year, 
                                column_date: column_date.date, 
                                index: i, 
                                newest_hour: this.newest_hour
                            }),
                            'alt_image': alt_src, 
                            'failed': false
                        });
                    }

                    for (let i=1; i <= index+1; i++) {
                        row_images.push({'src': null, 'alt_image': alt_src, 'failed': false})
                    }

                    structured_images[column_date.date] = row_images
                });

                this.column_dates.slice(3, this.column_dates.length).forEach((column_date, index) => {
                    const row_images = []
                    
                    for (let i=1+index; i <= this.row_dates.length-3; i++) {
                        row_images.push({
                            'src': this.generate_file_name({
                                atlas_root_dir, 
                                images_dir: this.images_dir, 
                                newest_year: column_date.year, 
                                column_date: column_date.date, 
                                index: i, 
                                newest_hour: this.newest_hour
                            }),
                            'alt_image': alt_src,
                            'failed': false});
                    }

                    for (let i=1; i <= index+3; i++) {
                        row_images.push({'src': null, 'alt_image': alt_src, 'failed': false});
                    }

                    structured_images[column_date.date] = row_images
                });
                
                this.structured_images = structured_images;
            },

            get_accumulated_precipitation_dates() {
                let accumulated_precipitation_dates = [];
                let calculated_date = new Date(this.newest_date);
                calculated_date.setDate(new Date(this.newest_date).getDate() + 1);
                for(let i=0; i<3; i++) {
                    let year = calculated_date.getFullYear();
                    let month = this.fillzero(calculated_date.getMonth() + 1);
                    let date = this.fillzero(calculated_date.getDate());
                    accumulated_precipitation_dates.push(year + "-" + month + "-" + date);
                    calculated_date.setDate(calculated_date.getDate() - 1);
                }
                return accumulated_precipitation_dates;
            },

            fillzero(s) {
                let r = String(s);
                if(r.length < 2)
                    return "0" + r;
                
                return r;
            },

            get_src(image, compression) {
                if (image.failed) {
                    return image.alt_image;
                } else if (image.src == null) {
                    return '';
                } else if (compression) {
                    let split_items = image.src.split("/");
                    split_items[split_items.length - 1] = "small_" + split_items[split_items.length - 1];
                    return split_items.join("/");
                } else {
                    return image.src;
                }
            },

            change_src(image) {
                image.failed = true; 
            },

            close_atlas_dialog() {
                this.dialog = false;
            },

            maintain_atlas_dialog() {
                event.stopPropagation()
            },

            show_detailed_picture(image) {
                const is_access_enlarge_image = image.src && !image.failed
                is_access_enlarge_image && this.$emit('open-image-dialog', image.src)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../../css/mixin";

    .table {
        overflow-x: auto;
        overflow-y: hidden;
        margin-top: .5rem;
        width: 100%;

        &::-webkit-scrollbar {
            display: none;
        }

        &__container {
            width: 100%;
            border-collapse: collapse;

            @include tablet {
                min-width: 1000px;
            }

            td {
                width: 76px;
                font-size: 14px;
                letter-spacing: 1px;
                line-height: 20px;
                color: var(--base_black);
            }

            tr {
                td:first-child {
                    border-left: unset;
                }
                td:last-child {
                    border-right: unset;
                }
            }
        }

        &__sidebar {
            font-weight: bold;
            background: var(--white-bg);
            border-top: 2px solid #fff;
            border-left: 2px solid #fff;
            border-right: 2px solid #fff;
        }

        &__header {
            padding: 6px;
            font-weight: bold;
            text-align: center;
            background: var(--white-bg);

            &__border {
                border-top: 2px solid #fff;
                border-right: 2px solid #fff;
                border-bottom: 2px solid #fff;
            }

            &__first {
                border: 2px solid #fff;
            }
        }
    }
</style>